import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-certificado',
  templateUrl: './main-certificado.component.html',
  styleUrls: ['./main-certificado.component.css']
})
export class MainCertificadoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
